import SvgIconStyle from '../components/SvgIconStyle';
import Iconify from '../components/iconify';

export const getIcon = (name) => (
    <SvgIconStyle
        src={`/assets/icons/nav/${name}.svg`}
        sx={{ width: 1, height: 1 }}
    />
);
export const getIconify = (name) => (
    <Iconify icon={name} sx={{ width: 1, height: 1 }} />
);

export const ICONS = {
    eye: 'eva:eye-fill',
    eyeSlash: 'eva:eye-off-fill',
    earth: 'mdi:earth',
    airplanetype: 'mdi:airplane',
    airport: 'mdi:airport',
    startEnd: 'mdi:ray-start-arrow',
    restaurant: 'mdi:silverware-fork-knife',
    attribute: 'mdi:silverware-fork-knife',
    booking: 'mdi:book-open-page-variant-outline',
    booking2: 'ic_booking',
    flight: 'mdi:airplane-takeoff',
    creditCard: 'ic:sharp-credit-card',
    takeoff: 'mdi:airplane-takeoff',
    passenger: 'mdi:seat-passenger',
    seat: 'mdi:car-seat',
    upload: 'mdi:file-image-plus-outline',
    cms: 'mdi:file-cog-outline',
    fileSetting: 'mdi:file-cog-outline',
    blogSVG: 'ic_blog',
    cartSVG: 'ic_cart',
    chatSVG: 'ic_chat',
    mailSVG: 'ic_mail',
    userSVG: 'ic_user',
    cancel: 'ic:baseline-cancel',
    check: 'ic:baseline-check-circle',
    user2: 'mdi:account-group',
    kanbanSVG: 'ic_kanban',
    bankingSVG: 'ic_banking',
    invoiceSVG: 'ic_invoice',
    calendarSVG: 'ic_calendar',
    ecommerceSVG: 'ic_ecommerce',
    analyticsSVG: 'ic_analytics',
    dashboardSVG: 'ic_dashboard',
    trash: 'eva:trash-2-outline',
    menuItemSVG: 'ic_menu_item',
    car: 'mdi:car',
    city: 'mdi:city-variant-outline',
    pdf: 'mdi:file-pdf-box',
    // buildings: 'mdi:domain',
    work: 'mdi:hammer-wrench',
    employees: 'mdi:account-hard-hat-outline',
    assignment: 'mdi:arrow-decision-outline',
    download: 'mdi:download-outline',
    room: 'fluent:conference-room-28-regular',
    roomType: 'fluent:conference-room-28-regular',
    checklist: 'bi:card-checklist',
    maintenance: 'wpf:maintenance',
    maintenanceType: 'wpf:maintenance',
    building: 'bx:building-house',
    // structureType: 'bi:card-checklist',
    supplyGroup: 'carbon:scis-transparent-supply',
    task: 'bx:task',
    taskGroup: 'bx:task',
    visitType: 'material-symbols:nest-doorbell-visitor-outline',
    customer: 'el:group',
    tags: 'ant-design:tags-outlined',
    home: 'ic:baseline-home',
    save: 'eva:save-fill',
    close: 'mdi:close-circle-outline',
    checked: 'mdi:check-circle-outline',
    cloud: 'mdi:image-filter-drama-outline',
    coupon: 'mdi:ticket-percent-outline',
};

export const ICON_COMPONENTS = {
    blog: getIcon('ic_blog'),
    cart: getIcon('ic_cart'),
    chat: getIcon('ic_chat'),
    mail: getIcon('ic_mail'),
    user: getIcon('ic_user'),
    kanban: getIcon('ic_kanban'),
    banking: getIcon('ic_banking'),
    booking: getIcon('ic_booking'),
    invoice: getIcon('ic_invoice'),
    calendar: getIcon('ic_calendar'),
    ecommerce: getIcon('ic_ecommerce'),
    analytics: getIcon('ic_analytics'),
    dashboard: getIcon('ic_dashboard'),
    menuItem: getIcon('ic_menu_item'),
    car: getIconify('mdi:car'),
    // buildings: getIconify('mdi:domain'),
    work: getIconify('mdi:hammer-wrench'),
    employees: getIconify('mdi:account-hard-hat-outline'),
    assignment: getIconify('mdi:arrow-decision-outline'),
    download: getIconify('mdi:download-outline'),
    room: getIconify('fluent:conference-room-28-regular'),
    roomType: getIconify('fluent:conference-room-28-regular'),
    checklist: getIconify('bi:card-checklist'),
    maintenance: getIconify('wpf:maintenance'),
    maintenanceType: getIconify('wpf:maintenance'),
    building: getIconify('bx:building-house'),
    // structureType: getIconify('bi:card-checklist'),
    supplyGroup: getIconify('carbon:scis-transparent-supply'),
    task: getIconify('bx:task'),
    taskGroup: getIconify('bx:task'),
    visitType: getIconify('material-symbols:nest-doorbell-visitor-outline'),
    customer: getIconify('el:group'),
    tags: getIconify('ant-design:tags-outlined'),
};
const ICONIFIED_ICONS = {};
